import TableForPolicy from "../tableForPolicy";
import TableForPrivacy from "../TableForPrivacy";

const PrivacyPolicy = () => {
  return (
    <div className="w-3/4 bg-[#04152d] lg:p-4 text-white leading-8">
      <h2 className="text-[32px] font-bold mb-4">
        POLITIQUE DE CONFIDENTIALITÉ
      </h2>
      <br></br>
      Cette politique de confidentialité s'applique entre vous, l'utilisateur de
      ce site Web, et Vivalimda Ltd., le propriétaire et le fournisseur de ce
      site Web. Vivalimda Ltd. prend la confidentialité de vos informations très
      au sérieux. La présente politique de confidentialité s'applique à notre
      utilisation de toutes les données que nous recueillons ou que vous
      fournissez dans le cadre de votre utilisation du site Web.
      <br></br>
      <br></br>
      La présente politique de confidentialité doit être lue en parallèle et en
      plus de nos conditions générales, qui peuvent être consultées à l'adresse
      suivante : www.motickets.co.uk.
      <br></br>
      <br></br>
      Veuillez lire attentivement cette politique de confidentialité. <br />{" "}
      <br></br>
      <h3 className="font-semibold text-xl">Définitions et interprétation</h3>
      <br></br>
      1. Dans la présente politique de confidentialité, les définitions
      suivantes sont utilisées:
      <TableForPolicy />
      <br></br>
      2. Dans la présente politique de confidentialité, à moins que le contexte
      n'exige une interprétation différente: <br></br>
      a. le singulier inclut le pluriel et vice versa; <br></br>
      b. les références aux sous-clauses, clauses, annexes ou annexes sont aux
      sous-clauses, clauses, annexes ou annexes de la présente politique de
      confidentialité ; <br></br> c. une référence à une personne comprend les
      entreprises, les sociétés, les entités gouvernementales, les fiducies et
      les partenariats;<br></br> d. « y compris » signifie « y compris, sans s'y
      limiter » ;<br></br> e. la référence à toute disposition législative
      comprend toute modification ou amendement de celle-ci;<br></br> f. les
      titres et sous-titres ne font pas partie de la présente politique de
      confidentialité.
      <br></br>
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">
        Champ d'application de la présente politique de confidentialité
      </h3>
      <br></br>
      3. Cette politique de confidentialité s'applique uniquement aux actions de
      Vivalimda Ltd. et des utilisateurs en ce qui concerne ce site Web. Elle ne
      s'étend pas aux sites Web accessibles à partir de ce site Web, y compris,
      mais sans s'y limiter, les liens que nous pouvons fournir vers des sites
      Web de médias sociaux. <br></br>
      4. Aux fins des lois applicables en matière de protection des données,
      Vivalimda Ltd. est le « contrôleur de données ». Cela signifie que
      Vivalimda Ltd. détermine les finalités et la manière dont vos données sont
      traitées.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Données collectées </h3>
      <br></br>
      5. Nous pouvons collecter les données suivantes, y compris les données
      personnelles, auprès de vous: <br></br>
      a. nom; <br></br>
      b. sexe; <br></br>
      c. informations de contact telles que les adresses e-mail et les numéros
      de téléphone; <br></br>
      d. informations démographiques telles que le code postal, les préférences
      et les centres d'intérêt;
      <br></br>
      e. adresse IP (collectée automatiquement);
      <br></br>
      f. f. __________ ; dans chaque cas, conformément à la présente politique
      de confidentialité.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">
        Comment nous collectons les données{" "}
      </h3>
      <br></br>
      6. Nous collectons les données de la manière suivante: <br></br>
      a. les données nous sont fournies par vous ;et
      <br></br>
      b. Les données sont collectées automatiquement. <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">
        Données que vous nous fournissez
      </h3>
      <br></br>
      7. Vivalimda Ltd. collectera vos données de plusieurs manières, par
      exemple: <br></br>
      a. lorsque vous nous contactez via le site Web, par téléphone, par
      courrier, par e-mail ou par tout autre moyen ;<br></br>
      b. lorsque vous nous effectuez des paiements, par le biais de ce site Web
      ou autrement;
      <br></br>
      c. lorsque vous choisissez de recevoir des communications marketing de
      notre part;
      <br></br>
      d. lorsque vous utilisez nos services ;<br></br>
      dans chaque cas, conformément à la présente politique de confidentialité.{" "}
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">
        Données collectées automatiquement{" "}
      </h3>
      <br></br>
      8. Dans la mesure où vous accédez au site Web, nous collecterons
      automatiquement vos données, par exemple:
      <br></br>
      a. nous recueillons automatiquement certaines informations sur votre
      visite sur le site Web. Ces informations nous aident à améliorer le
      contenu et la navigation du site Web, et comprennent votre adresse IP, la
      date, l'heure et la fréquence auxquelles vous accédez au site Web et la
      façon dont vous utilisez et interagissez avec son contenu.
      <br></br>
      b. nous collecterons automatiquement vos données via des cookies,
      conformément aux paramètres des cookies de votre navigateur. Pour plus
      d'informations sur les cookies et la manière dont nous les utilisons sur
      le site Web, consultez la section ci-dessous, intitulée « Cookies ».
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Notre utilisation des données</h3>
      <br></br>
      9. Tout ou partie des données ci-dessus peuvent être requises par nous de
      temps à autre afin de vous fournir le meilleur service et la meilleure
      expérience possibles lors de l'utilisation de notre site Web. Plus
      précisément, nous pouvons utiliser les données pour les raisons suivantes:
      <br></br>
      a. tenue de registres internes;
      <br></br>
      b. amélioration de nos produits/services;
      <br></br>
      c. __________;
      <br></br>
      dans chaque cas, conformément à la présente politique de confidentialité.
      <br></br>
      10. Nous pouvons utiliser vos données aux fins ci-dessus si nous le
      jugeons nécessaire pour nos intérêts légitimes. Si vous n'êtes pas
      satisfait de cela, vous avez le droit de vous y opposer dans certaines
      circonstances (voir la section intitulée « Vos droits » ci-dessous).
      <h3 className="font-semibold text-xl">
        Avec qui partageons-nous les données ?
      </h3>
      <br></br>
      11. Nous pouvons partager vos données avec les groupes de personnes
      suivants pour les raisons suivantes:
      <br></br>
      a. l'une des sociétés de notre groupe ou des sociétés affiliées - pour
      assurer la bonne administration de votre site Web et de votre entreprise ;
      <br></br>
      b. nos employés, agents et/ou conseillers professionnels - pour obtenir
      des conseils de conseillers professionnels ;<br></br>
      c. fournisseurs de paiement tiers qui traitent les paiements effectués sur
      le site Web - pour permettre aux fournisseurs de paiement tiers de traiter
      les paiements et les remboursements des utilisateurs ;<br></br>
      d. autorités compétentes - faciliter la détection d'infractions ou la
      perception d'impôts ou de droits ; dans chaque cas, conformément à la
      présente politique de confidentialité.
      <br></br>
      <h3 className="font-semibold text-xl">
        Avec qui partageons-nous les données ?
      </h3>
      <br></br>
      12. Nous utiliserons des mesures techniques et organisationnelles pour
      protéger vos données, par exemple :<br></br>
      a. l'accès à votre compte est contrôlé par un mot de passe et un nom
      d'utilisateur qui vous sont propres.
      <br></br>
      b. nous stockons vos données sur des serveurs sécurisés.
      <br></br>
      13. Les mesures techniques et organisationnelles comprennent des mesures
      visant à faire face à toute violation présumée de données. Si vous
      soupçonnez une utilisation abusive, une perte ou un accès non autorisé à
      vos données, veuillez nous en informer immédiatement en nous contactant
      via l'adresse e-mail suivante : help@motickets.co.uk.
      <br></br>
      14. Si vous souhaitez obtenir des informations détaillées de Get Safe
      Online sur la façon de protéger vos informations ainsi que vos ordinateurs
      et appareils contre la fraude, le vol d'identité, les virus et de nombreux
      autres problèmes en ligne, veuillez consulter www.getsafeonline.org. Get
      Safe Online est soutenu par le gouvernement de Sa Majesté et des
      entreprises de premier plan.
      <br></br>
      <h3 className="font-semibold text-xl">Conservation des données</h3>
      <br></br>
      15. À moins qu'une période de conservation plus longue ne soit requise ou
      autorisée par la loi, nous ne conserverons vos données sur nos systèmes
      que pendant la période nécessaire pour atteindre les objectifs décrits
      dans la présente politique de confidentialité ou jusqu'à ce que vous
      demandiez que les données soient supprimées.
      <br></br>
      16. Même si nous supprimons vos Données, celles-ci peuvent persister sur
      des supports de sauvegarde ou d'archivage à des fins juridiques, fiscales
      ou réglementaires.
      <br></br>
      <h3 className="font-semibold text-xl">Vos droits</h3>
      <br></br>
      17. Vous disposez des droits suivants en ce qui concerne vos Données:
      <br></br>
      a. Droit d'accès - le droit de demander (i) des copies des informations
      que nous détenons à votre sujet à tout moment, ou (ii)que nous modifiions,
      mettions à jour ou supprimions ces informations. Si nous vous donnons
      accès aux informations que nous détenons à votre sujet, nous ne vous
      facturerons pas ces informations, sauf si votre demande est «
      manifestement infondée ou excessive ». Lorsque nous sommes légalement
      autorisés à le faire, nous pouvons refuser votre demande. Si nous refusons
      votre demande, nous vous en indiquerons les raisons. Droit de
      rectification - le droit de faire rectifier vos données si elles sont
      inexactes ou incomplètes.c. Droit à l'effacement - le droit de demander
      que nous supprimions ou retirions vos données de nos systèmes. Droit de
      restreindre notre utilisation de vos données - le droit de nous « bloquer
      » dans l'utilisation de vos données ou de limiter la manière dont nous
      pouvons les utiliser. Droit à la portabilité des données - le droit de
      demander que nous déplacions, copions ou transférions vos données. Droit
      d'opposition - le droit de s'opposer à notre utilisation de vos données, y
      compris lorsque nous les utilisons pour nos intérêts légitimes.
      <br></br>
      18. Pour poser des questions, exercer l'un de vos droits énoncés ci-dessus
      ou retirer votre consentement au traitement de vos données (lorsque le
      consentement est notre base juridique pour le traitement de vos données),
      veuillez nous contacter à l'adresse e-mail suivante :
      help@motickets.co.uk.
      <br></br>
      19. Si vous n'êtes pas satisfait de la manière dont nous traitons une
      plainte que vous déposez concernant vos données, vous pouvez être en
      mesure de soumettre votre plainte à l'autorité compétente en matière de
      protection des données. Pour le Royaume-Uni, il s'agit de l'Information
      Commissioner's Office (ICO). Les coordonnées de l'ICO se trouvent sur son
      site Web à l'adresse https://ico.org.uk/. <br></br>
      20. Il est important que les données que nous détenons à votre sujet
      soient exactes et à jour. Veuillez nous tenir informés si vos données
      changent pendant la période pendant laquelle nous les conservons.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Liens vers d'autres sites Web</h3>
      <br></br>
      21. Ce site Web peut, de temps à autre, fournir des liens vers d'autres
      sites Web. Nous n'avons aucun contrôle sur ces sites Web et ne sommes pas
      responsables du contenu de ces sites Web. Cette politique de
      confidentialité ne s'étend pas à votre utilisation de ces sites Web. Il
      vous est conseillé de lire la politique de confidentialité ou la
      déclaration d'autres sites Web avant de les utiliser.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">
        Changements de propriété et de contrôle de l'entreprise{" "}
      </h3>
      <br></br>
      22. Vivalimda Ltd. peut, de temps à autre, étendre ou réduire ses
      activités, ce qui peut impliquer la vente et/ou le transfert de contrôle
      de tout ou partie de Vivalimda Ltd. Les données fournies par les
      utilisateurs, lorsqu'elles sont pertinentes pour une partie de notre
      entreprise ainsi transférée, seront transférées avec cette partie et le
      nouveau propriétaire ou la nouvelle partie contrôlante sera, selon les
      termes de la présente politique de confidentialité, autorisé à utiliser
      les données aux fins pour lesquelles elles nous ont été initialement
      fournies. <br></br>
      23. Nous pouvons également divulguer des données à un acheteur potentiel
      de notre entreprise ou d'une partie de celle-ci.
      <br></br>
      24. Dans les cas ci-dessus, nous prendrons des mesures dans le but
      d'assurer la protection de votre vie privée.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Cookies </h3>
      <br></br>
      25. Ce site Web peut placer et accéder à certains cookies sur votre
      ordinateur. Vivalimda Ltd. utilise des cookies pour améliorer votre
      expérience d'utilisation du site Web et pour améliorer notre gamme de
      produits. Vivalimda Ltd. a soigneusement choisi ces cookies et a pris des
      mesures pour s'assurer que votre vie privée est protégée et respectée à
      tout moment.
      <br></br>
      26. Tous les cookies utilisés par ce site Web sont utilisés conformément à
      la législation britannique et européenne en vigueur sur les cookies.
      <br></br>
      27. Avant que le site Web ne place des cookies sur votre ordinateur, une
      barre de message vous demandera votre consentement pour installer ces
      cookies. En donnant votre consentement au placement de cookies, vous
      permettez à Vivalimda Ltd. de vous offrir une meilleure expérience et un
      meilleur service. Vous pouvez, si vous le souhaitez, refuser votre
      consentement au dépôt de Cookies ; cependant, certaines fonctionnalités du
      site Web peuvent ne pas fonctionner pleinement ou comme prévu.
      <br></br>
      28. Ce site Web peut placer les cookies suivants :
      <TableForPrivacy />
      <br></br>
      29. Vous pouvez trouver une liste des cookies que nous utilisons dans
      l'annexe sur les cookies.
      <br></br>
      30. Vous pouvez choisir d'activer ou de désactiver les cookies dans votre
      navigateur Internet. Par défaut, la plupart des navigateurs Internet
      acceptent les cookies, mais cela peut être modifié. Pour plus de détails,
      veuillez consulter le menu d'aide de votre navigateur Internet. Vous
      pouvez désactiver les cookies à tout moment, mais vous risquez de perdre
      toute information vous permettant d'accéder au site Web plus rapidement et
      plus efficacement.
      <br></br>
      31. Il est recommandé de vous assurer que votre navigateur Internet est à
      jour et de consulter l'aide et les conseils fournis par le développeur de
      votre navigateur Internet si vous n'êtes pas sûr de pouvoir ajuster vos
      paramètres de confidentialité.
      <br></br>
      32. Pour plus d'informations sur les cookies de manière générale, y
      compris sur la façon de les désactiver, veuillez consulter
      aboutcookies.org. Vous trouverez également des détails sur la façon de
      supprimer les cookies de votre ordinateur.
      <br></br>
      33. For more information generally on cookies, including how to disable
      them, please refer to aboutcookies.org. You will also find details on how
      to delete cookies from your computer.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Généralités </h3>
      <br></br>
      34. Vous ne pouvez transférer aucun de vos droits en vertu de la présente
      politique de confidentialité à une autre personne. Nous pouvons transférer
      nos droits en vertu de la présente politique de confidentialité lorsque
      nous pensons raisonnablement que vos droits ne seront pas affectés.
      <br></br>
      35. Si un tribunal ou une autorité compétente constate qu'une disposition
      de la présente politique de confidentialité (ou une partie d'une
      disposition) est invalide, illégale ou inapplicable, cette disposition ou
      partie de disposition sera, dans la mesure requise, réputée supprimée, et
      la validité et l'applicabilité des autres dispositions de la présente
      politique de confidentialité n'en seront pas affectées.
      <br></br>
      36. Sauf accord contraire, aucun retard, acte ou omission d'une partie
      dans l'exercice d'un droit ou d'un recours ne sera considéré comme une
      renonciation à ce droit ou à tout autre droit ou recours.
      <br></br>
      37. Le présent Accord sera régi et interprété conformément au droit de
      l'Angleterre et du Pays de Galles. Tous les litiges découlant de l'Accord
      seront soumis à la juridiction exclusive des tribunaux anglais et gallois.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">
        Modifications de la présente politique de confidentialité
      </h3>
      <br></br>
      38. Vivalimda Ltd. se réserve le droit de modifier cette politique de
      confidentialité si nous le jugeons nécessaire de temps à autre ou si la
      loi l'exige. Toute modification sera immédiatement affichée sur le site
      Web et vous êtes réputé avoir accepté les termes de la politique de
      confidentialité lors de votre première utilisation du site Web à la suite
      des modifications. Vous pouvez contacter Vivalimda Ltd. par e-mail à
      l'help@motickets.co.uk.
      <br></br>
      <br></br>
      Cette politique de confidentialité a été créée le 01 février 2024.{" "}
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Cookies </h3>
      <br></br>
      Vous trouverez ci-dessous une liste des cookies que nous utilisons. Nous
      avons essayé de nous assurer qu'il est complet et à jour, mais si vous
      pensez que nous avons oublié un cookie ou qu'il y a une anomalie, veuillez
      nous le faire savoir.
      <br></br>
      <br></br>
      Strictement nécessaire <br></br>
      <br></br>
      Nous utilisons les cookies strictement nécessaires suivants :<br></br>
      <div className=" mx-auto p-4 contain">
        <table className=" bg-white border border-gray-300 ">
          <thead>
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                Description
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                Purpose
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-gray-100 border-b text-black">
              <td className="px-6 py-4 whitespace-wrap">
                Nous utilisons ce cookie de session pour nous souvenir de vous
                et maintenir votre session pendant que vous utilisez notre site
                Web
              </td>
              <td className="px-6 py-4 whitespace-wrap">
                Nous utilisons ce cookie de session pour nous souvenir de vous
                et maintenir votre session pendant que vous utilisez notre site
                Web{" "}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br></br>
      <h3 className="font-semibold text-xl">Fonctionnalité </h3>
      <br></br>
      Nous utilisons les cookies de fonctionnalité suivants :<br></br>
      <div className=" mx-auto p-4 contain">
        <table className=" bg-white border border-gray-300 ">
          <thead>
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                Description
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                But
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-gray-100 border-b text-black">
              <td className="px-6 py-4 whitespace-wrap">
                Nous utilisons ce cookie de session pour nous souvenir de vous
                et maintenir votre session pendant que vous utilisez notre site
                Web{" "}
              </td>
              <td className="px-6 py-4 whitespace-wrap">
                Nous utilisons ce cookie de session pour nous souvenir de vous
                et maintenir votre session pendant que vous utilisez notre site
                Web
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Cookies </h3>
      <br></br>
      Nous utilisons les cookies analytiques/de performance suivants :<br></br>
      <div className=" mx-auto p-4 contain">
        <table className=" bg-white border border-gray-300 ">
          <thead>
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                Description
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                Purpose
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-gray-100 border-b text-black">
              <td className="px-6 py-4 whitespace-wrap">
                Nous utilisons ce cookie pour identifier votre ordinateur et
                analyser les modèles de trafic sur notre site Web{" "}
              </td>
              <td className="px-6 py-4 whitespace-wrap">
                Nous utilisons ce cookie pour identifier votre ordinateur et
                analyser les modèles de trafic sur notre site Web{" "}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
